import { Bell } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/app/providers';
import { ROUTES } from '@/config/constants';
import { cn } from '@/lib/utils';
import { useIncomingFriendRequests } from '../hooks/useSocial';

/**
 * TopNav notifications bell. Lives in the slot the old "Return to last community"
 * button occupied — same round glass chrome — but clicks through to the full
 * Notifications page (`/notifications`) rather than opening a dropdown. The unread
 * badge mirrors the count the removed sidebar Notifications link used to show.
 * Account-scoped: renders nothing for signed-out visitors.
 */
export function NotificationBell() {
  const { user } = useAuth();
  const { data: requests = [] } = useIncomingFriendRequests(user?.id);
  const count = requests.length;

  if (!user) return null;

  return (
    <NavLink
      to={ROUTES.notifications}
      aria-label="Notifications"
      className={({ isActive }) =>
        cn(
          'relative grid h-9 w-9 place-items-center rounded-full border border-white/[0.08] bg-white/[0.035] text-white/70 transition-all',
          'hover:-translate-y-px hover:border-accent/35 hover:bg-accent/12 hover:text-accent',
          isActive && 'border-accent/35 bg-accent/12 text-accent',
        )
      }
    >
      <Bell size={17} strokeWidth={2.2} />
      {count > 0 && (
        <span className="absolute -right-1 -top-1 grid h-4 min-w-[16px] place-items-center rounded-full bg-red-500 px-1 text-[9px] font-black text-white">
          {count > 9 ? '9+' : count}
        </span>
      )}
    </NavLink>
  );
}
